/**
 * Shared pixel contract parsing for pool config payloads.
 */

import { warn } from '../../util/log';
import type { Pixel, PixelPlatform } from './types';

const KNOWN_PLATFORMS: ReadonlySet<PixelPlatform> = new Set([
  'facebook',
  'google',
  'pinterest',
  'quora',
  'taboola',
  'outbrain',
  'baidu',
]);

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/** Parses one pixel-ish object — used by both public `/public` configs and `/id` adapters. */
export function tryParseSdkPixelForConfig(entry: unknown): Pixel | null {
  if (!isObject(entry)) return null;
  const platform = (entry as { platform?: unknown }).platform;
  const pixel_id = (entry as { pixel_id?: unknown }).pixel_id;
  if (typeof platform !== 'string' || typeof pixel_id !== 'string' || !pixel_id) {
    warn('skipping pixel with missing platform/pixel_id', entry);
    return null;
  }
  if (!KNOWN_PLATFORMS.has(platform as PixelPlatform)) {
    warn(`skipping pixel with unknown platform: ${platform}`);
    return null;
  }
  return entry as unknown as Pixel;
}
